/** 회사 연혁 (엑셀 시트 기준, 중복 제거·시트·행 순서 유지) */
export const COMPANY_HISTORY = [
    {
        "period": "22년 11월",
        "text": "(주)엘지유플러스_유독타사가입을 위한 U+ID회원가입_전사채널_OTT연동관리"
    },
    {
        "period": "22년 11월",
        "text": "신한카드(주)_신한금융그룹 유니버셜 간편앱 시스템 구축_Vue.js 퍼블리싱_프론트개발"
    },
    {
        "period": "22년 11월",
        "text": "(주)엘지화학_공상평 Singlex HR 시스템_인사_모바일"
    },
    {
        "period": "22년 11월",
        "text": "(주)엘지씨엔에스_모바일 DI Shared 개발센터_DevOn Mobile iOS 앱 개발"
    },
    {
        "period": "22년 10월",
        "text": "엘지전자 (주)Order Portal Pre_Task_신규주문Portal_UI 퍼블리싱"
    },
    {
        "period": "22년 8월",
        "text": "(주)엘지씨엔에스_공상평_SINGLEX HR_모바일_유지보수"
    },
    {
        "period": "22년 8월",
        "text": "(주) 국민은행_KB국민은행 리브 Reboot One 구축_프론트 업무개발_자산관리"
    },
    {
        "period": "22년 8월",
        "text": "(주) 엘지유플러스 전사 대표 디지털 채널 구축 3단계(개발)_사용자_관리자_퍼블리싱 고도화"
    },
    {
        "period": "22년 7월",
        "text": "(주)엘지씨엔에스_VMS 시스템 구축 _퍼블리싱 (React)"
    },
    {
        "period": "22년 6월",
        "text": "(주)엘지유플러스 SM 서비스채널팀_전사디지털 채널"
    },
    {
        "period": "22년 6월",
        "text": "(주)LG CNS : EMS 플랫폼 Java 및 Cloud Native 전환 (모바일 백엔드 서비스 개발)"
    },
    {
        "period": "22년 6월",
        "text": "(주)LG유플러스 : 전사 차세대 UCube(현행화/정산) 구축 및 디지털 채널 고도화"
    },
    {
        "period": "22년 6월",
        "text": "(주)엘지유플러스 전사디지털채널OTT대응 상시개발_UI개발"
    },
    {
        "period": "22년 5월",
        "text": "(주)LG CNS : 스마트시티 플랫폼 'Cityhub' 관리자 포털 구축"
    },
    {
        "period": "22년 5월",
        "text": "엘지이노텍(주) : 제조·물류 효율화를 위한 ERP 연동 화물차량 검사 앱시스템"
    },
    {
        "period": "22년 4월",
        "text": "(주)LG유플러스 : 마이데이터(MyData) 플랫폼 구축 및 채널 개발"
    },
    {
        "period": "22년 4월",
        "text": "TriStar Electronic : Korea Renewal 프로젝트 수행"
    },
    {
        "period": "22년 4월",
        "text": "(주)LG유플러스 : 전사 데이터레이크(Data Lake) 구축 2차 포털 디자인 및 퍼블리싱"
    },
    {
        "period": "22년 4월",
        "text": "(주)엘지씨엔에스_Cityhub 관리자 포털_퍼블리싱 / Cityhub Innovation Committee 과제"
    },
    {
        "period": "22년 3월",
        "text": "(주)LG CNS : 엔터프라이즈 모빌리티(EMS) DI Shared 개발센터 운영 및 모바일 서비스 개발"
    },
    {
        "period": "22년 2월",
        "text": "(주)LG CNS : LG그룹 차세대 통합 SaaS 'Singlex' HR 인사 시스템"
    },
    {
        "period": "22년 1월",
        "text": "(주)LG화학 : 전사 통합 출입관리 시스템 구축 및 퍼블리싱"
    },
    {
        "period": "22년 1월",
        "text": "(주)엘지유플러스 홈인 서비스 시스템 운영 개발"
    },
    {
        "period": "22년 1월",
        "text": "데이터레이크 구축"
    },
    {
        "period": "22년 1월",
        "text": "㈜신한은행 SOL 앱 개발"
    },
    {
        "period": "22년 1월",
        "text": "W-Mall 고도화"
    },
    {
        "period": "22년 1월",
        "text": "한화솔루션 : 테크센싱(Tech-Sensing) 프로젝트 수행"
    },
    {
        "period": "22년 1월",
        "text": "GS About Pet 2022"
    },
    {
        "period": "22년 1월",
        "text": "(주)엘지씨엔에스 EMS DI Shared 개발센터_EMS(Mobile Office)_모바일 서비스 운영_서버"
    },
    {
        "period": "22년 1월",
        "text": "(주)엘지씨엔에스 EMS DI Shared 개발센터_EMS(Mobile Office)_모바일 서비스 개발 및 운영지원"
    },
    {
        "period": "22년 1월",
        "text": "(주)엘지씨엔에스 모바일 DI Shared 개발센터_Mobile Native App"
    },
    {
        "period": "22년 1월",
        "text": "(주)LG CNS : 모바일/EMS DI Shared 개발센터 운영 및 Mobile Native/Hybrid 앱 개발"
    },
    {
        "period": "22년 1월",
        "text": "(주)엘지씨엔에스 모바일 DI Shared 개발센터_Hybrid 화면 개발"
    },
    {
        "period": "22년 1월",
        "text": "(주)엘지씨엔에스 EMS DI Shared 개발센터_EMS(Mobile Office)_모바일 서비스 개발 및 운영 지원_서버"
    },
    {
        "period": "22년 1월",
        "text": "(주)엘지씨엔에스 모바일플랫폼 솔루션 관리(MA)_MDM개발 및 유지보수_Server, Android, iOS 개발"
    },
    {
        "period": "22년 1월",
        "text": "(주)엘지씨엔에스 모바일 DI Shared 개발센터_Hybrid 화면 개발, React"
    },
    {
        "period": "22년 1월",
        "text": "(주)엘지씨엔에스 모바일 DI Shared 개발센터_모바일앱 디자인퍼블리싱"
    },
    {
        "period": "22년 1월",
        "text": "(주)엘지유플러스 Data Lake 구축_퍼블리셔"
    },
    {
        "period": "22년 1월",
        "text": "㈜신한은행 : New SOL 앱 고도화 구축 및 금융 채널 React 프레임워크 공통 적용"
    },
    {
        "period": "22년 1월",
        "text": "㈜신한은행_㈜ SOL 고도화 구축 사업_React 금융 채널 적용을 위한 사전 확인_프레임웍"
    },
    {
        "period": "23년 12월",
        "text": "(주)LG CNS : 모바일 Push 관리 콘솔 Spring Boot 전환 및 ML Kit 기반 핵심 자산(Asset) 개발"
    },
    {
        "period": "23년 12월",
        "text": "(주)LG CNS : AI 및 모바일 플랫폼 아키텍처 고도화 프로젝트 수행"
    },
    {
        "period": "23년 10월",
        "text": "한화생명보험(주) : 라이프플러스(LIFEPLUS) 아카데미 고도화 및 기술 공통 프레임워크 개발"
    },
    {
        "period": "23년 9월",
        "text": "(주)LG CNS : 빌드센터(Build Center) AI Playground 플랫폼 구축 및 웹 서비스 개발"
    },
    {
        "period": "23년 8월",
        "text": "(주)LG유플러스 : 삼성/애플 웹시트 및 전사 채널 가입·개통 연동 시스템 및 Entitlement 서버 통합 운영"
    },
    {
        "period": "23년 8월",
        "text": "엘지이노텍(주) : 본사 G-Mobile 시스템 최적화 및 개인화 서비스 기반 UX 고도화"
    },
    {
        "period": "23년 7월",
        "text": "(주)LG유플러스 : 유독(UUDOK) 서비스 DX 사업 채널 고도화 및 uCube 현행화 API 분석"
    },
    {
        "period": "23년 7월",
        "text": "(주)엘지유플러스 2023년 LG유플러스 상시개발 채널DX사업팀_유독서비스"
    },
    {
        "period": "23년 6월",
        "text": "(주)신한은행 : 신한금융 유니버셜 간편 앱 구축 (Vue.js 기반 차세대 UI/UX 적용)"
    },
    {
        "period": "23년 3월",
        "text": "(주)엘지유플러스 전사채널로밍 기능개선_로밍PC 기능 개선 개발"
    },
    {
        "period": "23년 1월",
        "text": "(주)엘지씨엔에스 EMS DI Shared 개발센터_모바일 서비스 운영 및 연계 서비스 개발"
    },
    {
        "period": "23년 1월",
        "text": "(주)엘지씨엔에스_모바일 Shared 개발센터_디자인/퍼블리싱"
    },
    {
        "period": "23년 1월",
        "text": "(주)LG CNS : SINGLEX HR 시스템 및 모바일 Shared 개발센터 통합 운영·유지보수"
    },
    {
        "period": "23년 1월",
        "text": "(주)LG CNS : 자사 모바일 보안 솔루션(MDM/DMS/EDM) 플랫폼 개발 및 서버 관리"
    },
    {
        "period": "23년 1월",
        "text": "(주)엘지씨엔에스 모바일플랫폼 솔루션 관리(MA)_자사 EDM 솔루션 개발 및 유지보수_Server_Frontend/Backend"
    },
    {
        "period": "24년 11월",
        "text": "(주)LG CNS : 오픈소스 및 솔루션(LENA, TunA) 미들웨어 관리 Web Admin Console UI/UX 컨설팅 및 퍼블리싱"
    },
    {
        "period": "24년 9월",
        "text": "(주)엘지씨엔에스_TunA 솔루션 개발 및 기술지원_미들웨어 관리 Web Admin Console UI/UX 컨설팅 및 퍼블리싱"
    },
    {
        "period": "24년 7월",
        "text": "엘지씨엔에스_LENA 솔루션 개발 및 기술지원_미들웨어 관리 Web Admin Console UI/UX 컨설팅 및 퍼블리싱"
    },
    {
        "period": "24년 6월",
        "text": "(주)미래엔 : AI 디지털 교과서 콘텐츠 구축 사업 수행 (초등 수학 3-1 React 기반 시스템)"
    },
    {
        "period": "24년 4월",
        "text": "(주)LG CNS : 차세대 모바일 플랫폼 및 하이브리드 앱(Shared Project) 프론트엔드 개발"
    },
    {
        "period": "24년 3월",
        "text": "(주)LG CNS : 글로벌 SAP ERP 검증 솔루션 'PerfecTwin for SAP' UI/UX 고도화"
    },
    {
        "period": "24년 1월",
        "text": "(주)LG CNS : LG그룹 통합 SaaS 'SINGLEX HR' 모바일 서비스 및 자사 모바일 솔루션(MA) 통합 관리"
    },
    {
        "period": "24년 1월",
        "text": "엘지씨엔에스_SINGLEX HR_모바일"
    },
    {
        "period": "25년 5월",
        "text": "주식회사 이온 : 에듀테크(Edutech) 온라인 학습 플랫폼 고도화 및 비즈니스 확장 구축"
    },
    {
        "period": "25년 5월",
        "text": "AIA생명보험(주) : 차세대 청약 시스템 및 상품/룰(Rule) 엔진 공통 컴포넌트 표준화 개발"
    },
    {
        "period": "25년 4월",
        "text": "(주)LG CNS (KB손해보험) : 대고객 디지털 시스템 아키텍처 방향성 수립 및 전략 컨설팅 수행"
    },
    {
        "period": "25년 1월",
        "text": "(주)LG CNS : 엔터프라이즈 모바일 플랫폼 솔루션 통합 관리 및 백엔드(Backend) 연계 개발"
    },
    {
        "period": "25년 1월",
        "text": "(주)LG CNS : LG그룹 통합 SaaS 'SINGLEX HR' 모바일 시스템 고도화(2025)"
    },
    {
        "period": "26년 1월",
        "text": "(주)LG CNS : LG그룹 차세대 통합 SaaS 'SINGLEX HR' 모바일 시스템 고도화 및 운영"
    },
    {
        "period": "26년 1월",
        "text": "(주)LG CNS : EMS DI Shared 개발센터 모바일 핵심 솔루션 개발 및 백엔드(Backend) 아키텍처 연계"
    }
];
